<template>
  <div v-if="items.length" class="ntf-wrapper">
    <transition-group name="fade" appear>
      <div
        v-for="item in items"
        :key="item.key"
        :class="['ntf', 'ntf-' + item.type]"
      >
        <div
          :class="[
            'icon',
            item.type === 'success' ? 'icon-success' : 'icon-important',
          ]"
        />
        <!-- eslint-disable vue/no-v-html -->
        <div class="ntf-content" v-html="item.text" />
        <div
          v-if="item.closable"
          class="icon icon-clear"
          @click="removeNoty(item.key)"
        />
      </div>
    </transition-group>
  </div>
</template>

<script setup>
import { items, removeNoty } from '@/libs/noty'
</script>

<style lang="scss">
.ntf-wrapper {
  position: fixed;
  left: 0;
  bottom: 0;
  padding: 16px;
  width: 100%;

  z-index: 101;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: 12px;
  height: auto;
  align-items: center;

  max-width: 996px;
  margin-left: 50%;
  transform: translateX(-50%);

  pointer-events: none;
}
</style>
